/** A pasted Drive folder link -> folder ID, or null when the text is not a link (so it stays a name filter).
    Same link shapes as the API's parseFolderId; the API re-checks the folder as the requester either way. */
export function folderIdFromLink(input: string): string | null {
  const s = input.trim()
  if (!/drive\.google\.com|docs\.google\.com/.test(s)) return null
  const m = s.match(/\/folders\/([A-Za-z0-9_-]{10,})/) ?? s.match(/[?&]id=([A-Za-z0-9_-]{10,})/)
  return m ? m[1] : null
}
